(function () {
  'use strict';

  // --- Country centers ----------------------------------------------------
  // Approximate geographic centers and display names for the countries our
  // dealer feed currently uses. The feed has casing/spelling variants for the
  // same country (e.g. USA / usa / USa / US, Canada / CANADA), so callers
  // should use canonicalCountry() as the *grouping key* — not the raw
  // dealer.country string — to keep one cluster per country.
  // Coordinates are [lng, lat] to match Mapbox conventions.
  var COUNTRIES = (function () {
    var map = {};
    function add(display, center, aliases) {
      var entry = { display: display, center: center };
      for (var i = 0; i < aliases.length; i++) {
        map[aliases[i].toLowerCase()] = entry;
      }
    }
    add('USA', [-98.5795, 39.8283], ['USA', 'usa', 'US', 'U.S.', 'U.S.A.', 'United States', 'United States of America']);
    add('Colombia', [-74.2973, 4.5709], ['Colombia', 'CO']);
    add('Bolivia', [-63.5887, -16.2902], ['Bolivia', 'BO']);
    add('Paraguay', [-58.4438, -23.4425], ['Paraguay', 'PY']);
    add('Iceland', [-19.0208, 64.9631], ['Iceland', 'IS']);
    add('Bulgaria', [25.4858, 42.7339], ['Bulgaria', 'BG']);
    add('Georgia', [43.3569, 42.3154], ['Georgia', 'GE']);
    add('Kazakhstan', [66.9237, 48.0196], ['Kazakhstan', 'KZ']);
    add('Morocco', [-7.0926, 31.7917], ['Morocco', 'MA']);
    add('Oman', [55.9754, 21.4735], ['Oman', 'OM']);
    add('Canada', [-106.3468, 56.1304], ['Canada', 'CA', 'CAN']);
    add('Mexico', [-102.5528, 23.6345], ['Mexico', 'MX', 'México']);
    add('United Kingdom', [-3.436, 55.3781], ['United Kingdom', 'UK', 'U.K.', 'Great Britain', 'England']);
    add('Australia', [133.7751, -25.2744], ['Australia', 'AU', 'AUS']);
    add('New Zealand', [174.886, -40.9006], ['New Zealand', 'NZ']);
    add('Germany', [10.4515, 51.1657], ['Germany', 'Deutschland', 'DE']);
    add('France', [2.2137, 46.2276], ['France', 'FR']);
    add('Italy', [12.5674, 41.8719], ['Italy', 'IT']);
    add('Spain', [-3.7492, 40.4637], ['Spain', 'ES', 'España']);
    add('Portugal', [-8.2245, 39.3999], ['Portugal', 'PT']);
    add('Netherlands', [5.2913, 52.1326], ['Netherlands', 'NL', 'Holland']);
    add('Belgium', [4.4699, 50.5039], ['Belgium', 'BE']);
    add('Switzerland', [8.2275, 46.8182], ['Switzerland', 'CH']);
    add('Austria', [14.5501, 47.5162], ['Austria', 'AT']);
    add('Ireland', [-7.6921, 53.1424], ['Ireland', 'IE']);
    add('Poland', [19.1451, 51.9194], ['Poland', 'PL']);
    add('Sweden', [18.6435, 60.1282], ['Sweden', 'SE']);
    add('Norway', [8.4689, 60.472], ['Norway', 'NO']);
    add('Denmark', [9.5018, 56.2639], ['Denmark', 'DK']);
    add('Finland', [25.7482, 61.9241], ['Finland', 'FI']);
    add('Greece', [21.8243, 39.0742], ['Greece', 'GR']);
    add('Russia', [105.3188, 61.524], ['Russia', 'Russian Federation', 'RU']);
    add('Ukraine', [31.1656, 48.3794], ['Ukraine', 'UA']);
    add('Latvia', [24.6032, 56.8796], ['Latvia', 'LV']);
    add('Turkey', [35.2433, 38.9637], ['Turkey', 'Türkiye', 'TR']);
    add('Israel', [34.8516, 31.0461], ['Israel', 'IL']);
    add('UAE', [53.8478, 23.4241], ['United Arab Emirates', 'UAE', 'U.A.E.', 'AE', 'Arab Emirates', 'Emirates']);
    add('Saudi Arabia', [45.0792, 23.8859], ['Saudi Arabia', 'SA', 'KSA']);
    add('Qatar', [51.1839, 25.3548], ['Qatar', 'QA']);
    add('Kuwait', [47.4818, 29.3117], ['Kuwait', 'KW']);
    add('Hong Kong', [114.1095, 22.3964], ['Hong Kong', 'HK']);
    add('Japan', [138.2529, 36.2048], ['Japan', 'JP']);
    add('China', [104.1954, 35.8617], ['China', 'CN']);
    add('South Korea', [127.7669, 35.9078], ['South Korea', 'Korea', 'KR']);
    add('India', [78.9629, 20.5937], ['India', 'IN']);
    add('Thailand', [100.9925, 15.87], ['Thailand', 'TH']);
    add('Philippines', [121.774, 12.8797], ['Philippines', 'PH']);
    add('Indonesia', [113.9213, -0.7893], ['Indonesia', 'ID']);
    add('Malaysia', [101.9758, 4.2105], ['Malaysia', 'MY']);
    add('Singapore', [103.8198, 1.3521], ['Singapore', 'SG']);
    add('Vietnam', [108.2772, 14.0583], ['Vietnam', 'VN', 'Viet Nam']);
    add('Brazil', [-51.9253, -14.235], ['Brazil', 'Brasil', 'BR']);
    add('Argentina', [-63.6167, -38.4161], ['Argentina', 'AR']);
    add('Chile', [-71.5430, -35.6751], ['Chile', 'CL']);
    add('Peru', [-75.0152, -9.19], ['Peru', 'PE', 'Perú']);
    add('Ecuador', [-78.1834, -1.8312], ['Ecuador', 'EC']);
    add('Venezuela', [-66.5897, 6.4238], ['Venezuela', 'VE']);
    add('Costa Rica', [-83.7534, 9.7489], ['Costa Rica', 'CR']);
    add('Puerto Rico', [-66.5901, 18.2208], ['Puerto Rico', 'PR']);
    add('Dominican Republic', [-70.1627, 18.7357], ['Dominican Republic', 'DR', 'DO']);
    add('Dominica', [-61.371, 15.415], ['Dominica', 'DM']);
    add('South Africa', [22.9375, -30.5595], ['South Africa', 'ZA', 'RSA']);
    add('Namibia', [18.4904, -22.9576], ['Namibia', 'Nambia', 'NA']);
    add('Mozambique', [35.5296, -18.6657], ['Mozambique', 'MZ']);
    return map;
  })();

  function lookupCountry(name) {
    if (!name) return null;
    var key = String(name).trim().toLowerCase();
    if (!key) return null;
    return COUNTRIES[key] || null;
  }

  function canonicalCountry(name) {
    var entry = lookupCountry(name);
    if (entry) return entry.display;
    var trimmed = (name == null ? '' : String(name)).trim();
    return trimmed || 'Other';
  }

  function getCountryCenter(name) {
    var entry = lookupCountry(name);
    return entry ? entry.center : null;
  }

  function compareCountries(a, b) {
    if (a === b) return 0;
    if (a === 'USA') return -1;
    if (b === 'USA') return 1;
    if (a === 'Other') return 1;
    if (b === 'Other') return -1;
    return a.localeCompare(b);
  }

  // --- Utils --------------------------------------------------------------
  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      switch (c) {
        case '&': return '&amp;';
        case '<': return '&lt;';
        case '>': return '&gt;';
        case '"': return '&quot;';
        case "'": return '&#039;';
        default: return c;
      }
    });
  }

  function normalizeDealer(raw, index) {
    var lat = NaN;
    var lng = NaN;
    if (raw.latlon) {
      var parts = String(raw.latlon).split(',');
      lat = parseFloat(parts[0]);
      lng = parseFloat(parts[1]);
    }

    var street = raw.street || '';
    var street2 = raw.street_2 || '';
    var streetCombined = [street, street2].filter(Boolean).join(', ');

    var zip = raw.zip || '';
    var cityStateZip = [raw.city, raw.state, zip].filter(Boolean).join(', ');
    if (zip) cityStateZip = cityStateZip.replace(', ' + zip, ' ' + zip);

    var addressLine = [streetCombined, cityStateZip].filter(Boolean).join(', ');
    // Reject obviously-bogus coordinates (NaN, out of range, or the (0, 0)
    // placeholder that some upstream feeds emit for un-geocoded rows).
    var inRange = lat >= -85 && lat <= 85 && lng >= -180 && lng <= 180;
    var isPlaceholder = lat === 0 && lng === 0;
    var hasLatLng = isFinite(lat) && isFinite(lng) && inRange && !isPlaceholder;
    var placeId = raw.place_id || '';
    var name = raw.name || 'EVP Dealer';
    var mapsUrl = placeId
      ? 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(name) + '&query_place_id=' + encodeURIComponent(placeId)
      : addressLine
        ? 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(addressLine)
        : '';

    return {
      id: 'dealer-' + (raw.id != null ? raw.id : index),
      name: raw.name || 'EVP Dealer',
      street: street,
      street2: street2,
      city: raw.city || '',
      state: raw.state || '',
      zip: zip,
      country: raw.country || '',
      lat: lat,
      lng: lng,
      hasLatLng: hasLatLng,
      addressLine: addressLine,
      mapsUrl: mapsUrl,
      distance: null,
    };
  }

  function getDistanceMiles(origin, dealer) {
    var R = 3958.8;
    var lat1 = (origin.lat * Math.PI) / 180;
    var lat2 = (dealer.lat * Math.PI) / 180;
    var dLat = ((dealer.lat - origin.lat) * Math.PI) / 180;
    var dLng = ((dealer.lng - origin.lng) * Math.PI) / 180;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function sortDealersForDefault(dealers) {
    return dealers.slice().sort(function (a, b) {
      var cc = compareCountries(canonicalCountry(a.country), canonicalCountry(b.country));
      if (cc !== 0) return cc;
      return (a.state + a.name).localeCompare(b.state + b.name);
    });
  }

  function geocodePostcode(query, token) {
    var url = new URL('https://api.mapbox.com/search/geocode/v6/forward');
    url.searchParams.set('q', query);
    url.searchParams.set('country', 'us');
    url.searchParams.set('types', 'postcode');
    url.searchParams.set('limit', '1');
    url.searchParams.set('access_token', token);
    return fetch(url.toString()).then(function (res) {
      if (!res.ok) throw new Error('Geocoding failed (' + res.status + ')');
      return res.json();
    }).then(function (data) {
      var feature = data && data.features && data.features[0];
      if (!feature || !feature.geometry || !feature.geometry.coordinates) return null;
      var coords = feature.geometry.coordinates;
      return { lat: coords[1], lng: coords[0], label: (feature.properties && feature.properties.full_address) || query };
    });
  }

  // --- Config / data reading ---------------------------------------------
  function readConfig(el) {
    var ds = el.dataset;
    return {
      mapboxToken: ds.mapboxToken || '',
      googleMapsApiKey: ds.googleMapsApiKey || '',
      defaultCenter: {
        lat: parseFloat(ds.defaultLat) || 39.8283,
        lng: parseFloat(ds.defaultLng) || -98.5795,
      },
      defaultZoom: parseInt(ds.defaultZoom, 10) || 4,
      radius: parseInt(ds.searchRadius, 10) || 250,
      limit: parseInt(ds.resultsLimit, 10) || 50,
      persistState: ds.persistState !== 'false',
      debug: ds.debug === 'true' || window.location.search.indexOf('dealer_debug=1') !== -1,
    };
  }

  // --- Persistence --------------------------------------------------------
  // Keep state across reloads in sessionStorage so users don't lose their
  // search on accidental refresh. Cleared automatically when the tab closes.
  function makeStorage(enabled, key) {
    if (!enabled) return { load: function () { return null; }, save: function () {}, clear: function () {} };
    var safeGet = function () {
      try { return window.sessionStorage; } catch (e) { return null; }
    };
    return {
      load: function () {
        var s = safeGet();
        if (!s) return null;
        try {
          var raw = s.getItem(key);
          return raw ? JSON.parse(raw) : null;
        } catch (e) { return null; }
      },
      save: function (value) {
        var s = safeGet();
        if (!s) return;
        try { s.setItem(key, JSON.stringify(value)); } catch (e) { /* quota/private mode */ }
      },
      clear: function () {
        var s = safeGet();
        if (!s) return;
        try { s.removeItem(key); } catch (e) { /* ignore */ }
      },
    };
  }

  // A persisted filter is only re-applied if its shape matches what
  // applyFilter expects today — defends against schema drift across deploys.
  function isValidPersistedFilter(f) {
    if (!f || typeof f !== 'object') return false;
    if (f.kind === 'country') return typeof f.country === 'string' && f.country.length > 0;
    if (f.kind === 'search' || f.kind === 'nearby') {
      return f.origin && isFinite(f.origin.lat) && isFinite(f.origin.lng);
    }
    return false;
  }

  // --- Google Places loader -----------------------------------------------
  // The Liquid template injects the Maps JS with `callback=evpDealerGooglePlacesReady`
  // and `libraries=places`. We register a single shared callback that fans
  // out to any locator instance that's waiting on Places.
  var googlePlacesPending = [];
  var googlePlacesReady = false;
  window.evpDealerGooglePlacesReady = function () {
    googlePlacesReady = true;
    var queued = googlePlacesPending;
    googlePlacesPending = [];
    for (var i = 0; i < queued.length; i++) {
      try { queued[i](); } catch (e) { /* ignore */ }
    }
  };
  function whenGooglePlacesReady(cb) {
    if (googlePlacesReady && window.google && window.google.maps && window.google.maps.places) {
      cb();
      return;
    }
    googlePlacesPending.push(cb);
  }

  function readDealers(section) {
    if (!section) return [];
    var dataScript = section.querySelector('script[data-dealer-data]');
    if (!dataScript) return [];
    try {
      var parsed = JSON.parse(dataScript.textContent || '[]');
      if (typeof parsed === 'string') parsed = JSON.parse(parsed);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function readCssVar(el, name, fallback) {
    var value = window.getComputedStyle(el).getPropertyValue(name).trim();
    return value || fallback;
  }

  // --- DealerLocator instance --------------------------------------------
  var MAP_STYLE = 'mapbox://styles/mapbox/standard';
  var COUNTRY_MAX = 4;
  var SUPER_MAX = 6;
  var SOURCE_ID = 'evp-dealers';
  var CLUSTER_SHADOW_LAYER = 'evp-dealer-clusters-shadow';
  var CLUSTER_LAYER = 'evp-dealer-clusters';
  var CLUSTER_COUNT_LAYER = 'evp-dealer-cluster-count';
  // Parallel layers for unclustered features. Supercluster only emits a
  // `point_count` cluster when at least one neighbor falls inside
  // `clusterRadius` — a country with one dealer (or any isolated point at
  // tight enough zoom) is emitted as a raw point. These layers render those
  // singletons with the same red-circle "1" badge as a cluster of 1.
  var UNCLUSTERED_SHADOW_LAYER = 'evp-dealer-unclustered-shadow';
  var UNCLUSTERED_LAYER = 'evp-dealer-unclustered';
  var UNCLUSTERED_COUNT_LAYER = 'evp-dealer-unclustered-count';

  var CLUSTER_RADIUS_EXPR = [
    'interpolate', ['linear'], ['get', 'point_count'],
    1, 16, 3, 19, 5, 22, 10, 26, 20, 30, 40, 36,
  ];
  var CLUSTER_SHADOW_RADIUS_EXPR = [
    'interpolate', ['linear'], ['get', 'point_count'],
    1, 28, 3, 31, 5, 34, 10, 38, 20, 43, 40, 50,
  ];

  function computeMode(zoom) {
    // Use <= at the boundary so a default zoom that exactly equals
    // COUNTRY_MAX (4) stays in country mode, not super. Floating-point
    // zoom drift during map settle can otherwise flip the mode under
    // initial render and cause a flicker.
    if (zoom <= COUNTRY_MAX) return 'country';
    if (zoom < SUPER_MAX) return 'super';
    return 'none';
  }

  function createElement(tag, className, attrs) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (attrs) {
      for (var k in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, k)) el.setAttribute(k, attrs[k]);
      }
    }
    return el;
  }

  function init(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var config = readConfig(root);
    var section = root.closest('section');
    var sectionId = (section && section.dataset && section.dataset.sectionId) || 'default';
    var storage = makeStorage(config.persistState, 'evp-dealer-locator:' + sectionId);
    var rawDealers = readDealers(section);
    var accentColor = readCssVar(root, '--dealer-accent', '#e60000');

    var allDealers = rawDealers
      .map(normalizeDealer)
      .filter(function (d) { return d.name && d.hasLatLng; });

    // --- State ---
    // `filter` is the single source of truth for what's shown.
    //   null                                                 — default view, all dealers
    //   { kind: 'country', country }                         — country cluster clicked
    //   { kind: 'search',  origin: {lat,lng}, query }        — zip search
    //   { kind: 'nearby',  origin: {lat,lng} }               — browser geolocation
    // `visibleDealers` is derived from `filter` via deriveVisible(); never set directly.
    var filter = null;
    var visibleDealers = deriveVisible(null);
    var selectedId = null;
    var loading = false;
    var fallback = null;
    var mapReady = false;
    var clusterMode = computeMode(config.defaultZoom);
    var map = null;
    var markers = [];
    var originMarker = null;
    var popup = null;
    var clusterClickHandler = null;
    var unclusteredClickHandler = null;
    // When true, renderMarkers still clears existing markers/layers but skips
    // re-rendering. Used during the reset flyTo so the map looks empty until
    // it lands at the default view.
    var suppressMarkerRender = false;

    // --- DOM references (markup is server-rendered in page_dealers.liquid) ---
    var form = root.querySelector('[data-dealer-search-form]');
    var zipInput = root.querySelector('[data-dealer-zip-input]');
    var submitBtn = form.querySelector('.dealer-locator__submit');
    var clearBtn = root.querySelector('[data-dealer-clear]');
    var nearbyBtn = root.querySelector('[data-dealer-nearby]');
    var list = root.querySelector('[data-dealer-list]');
    var mapEl = root.querySelector('[data-dealer-map]');
    var resetBtn = root.querySelector('[data-dealer-reset]');
    var fallbackEl = root.querySelector('[data-dealer-fallback]');

    // --- Renderers ---
    function setLoading(value) {
      loading = value;
      submitBtn.disabled = value;
      nearbyBtn.disabled = value;
    }

    function setFallback(message) {
      fallback = message;
      if (message) {
        fallbackEl.innerHTML =
          '<div><h2>Map Loading</h2><p>' + escapeHtml(message) + '</p></div>';
        fallbackEl.classList.add('is-visible');
      } else {
        fallbackEl.classList.remove('is-visible');
        fallbackEl.innerHTML = '';
      }
    }

    function deriveVisible(f) {
      if (!f) return sortDealersForDefault(allDealers);

      if (f.kind === 'country') {
        return allDealers.filter(function (d) {
          return canonicalCountry(d.country) === f.country;
        });
      }

      // search / nearby: distance-rank from origin, prefer within-radius,
      // fall back to N closest when nothing falls inside the radius.
      var withDistance = allDealers
        .filter(function (d) { return d.hasLatLng; })
        .map(function (d) {
          return Object.assign({}, d, { distance: getDistanceMiles(f.origin, d) });
        });

      var byDistance = withDistance.slice().sort(function (a, b) {
        return (a.distance || 0) - (b.distance || 0);
      });

      var withinRadius = byDistance.filter(function (d) {
        return (d.distance != null ? d.distance : Infinity) <= config.radius;
      });

      if (withinRadius.length === 0) {
        return byDistance.slice(0, config.limit);
      }
      return withinRadius.slice(0, config.limit);
    }

    function applyFilter(next) {
      filter = next;
      visibleDealers = deriveVisible(filter);
      selectedId = null;
      if (popup) { popup.remove(); popup = null; }
      if (filter && filter.kind === 'country') {
        zipInput.value = filter.country;
        updateClearBtn();
      }
      renderOriginMarker();
      renderList();
      // Clear the existing marker layer immediately, then wait for the
      // camera animation to settle before placing the new markers —
      // otherwise they'd be projected against a moving camera and visibly
      // slide into their final positions.
      suppressMarkerRender = true;
      renderMarkers();
      suppressMarkerRender = false;
      applyMapView();
      if (mapReady && map) {
        map.once('moveend', function () {
          renderMarkers();
        });
      }
      updateResetButton();
      persistCurrentState();
    }

    function persistCurrentState() {
      if (!config.persistState) return;
      if (!filter && !zipInput.value) {
        storage.clear();
        return;
      }
      storage.save({
        filter: filter,
        queryText: zipInput.value || '',
      });
    }

    function updateResetButton() {
      var zoomedOut = map && Math.abs(map.getZoom() - config.defaultZoom) > 0.05;
      resetBtn.style.display = (filter || zoomedOut) ? '' : 'none';
    }

    function applyMapView() {
      if (!mapReady || !map) return;

      if (!filter) {
        map.flyTo({
          center: [config.defaultCenter.lng, config.defaultCenter.lat],
          zoom: config.defaultZoom,
          essential: true,
        });
        return;
      }

      if (filter.kind === 'country') {
        // Pan to the country center (or dealers' centroid as fallback) and
        // zoom just past COUNTRY_MAX so the country cluster breaks apart
        // into city-level clusters. Covers both the cluster-click path and
        // the restore-from-storage path.
        var center = getCountryCenter(filter.country);
        if (!center) {
          var dealers = visibleDealers.filter(function (d) { return d.hasLatLng; });
          if (dealers.length === 0) return;
          var sumLng = 0;
          var sumLat = 0;
          for (var i = 0; i < dealers.length; i++) { sumLng += dealers[i].lng; sumLat += dealers[i].lat; }
          center = [sumLng / dealers.length, sumLat / dealers.length];
        }
        map.easeTo({ center: center, zoom: COUNTRY_MAX + 0.25, duration: 600 });
        return;
      }

      // search / nearby: fit bounds across origin + visible dealers
      var dealersWithCoords = visibleDealers.filter(function (d) { return d.hasLatLng; });
      if (dealersWithCoords.length === 0) {
        map.flyTo({
          center: [filter.origin.lng, filter.origin.lat],
          zoom: 10,
          essential: true,
        });
        return;
      }
      var bounds = new window.mapboxgl.LngLatBounds();
      bounds.extend([filter.origin.lng, filter.origin.lat]);
      dealersWithCoords.forEach(function (d) { bounds.extend([d.lng, d.lat]); });
      map.fitBounds(bounds, { padding: 60, maxZoom: 10, duration: 600 });
    }

    function renderOriginMarker() {
      if (originMarker) { originMarker.remove(); originMarker = null; }
      if (!mapReady || !map || !filter || !filter.origin) return;

      var el = createElement('div', 'dealer-locator__marker dealer-locator__origin');
      var dot = createElement('span', 'dealer-locator__marker-dot');
      el.appendChild(dot);

      // Hide the marker for the first two frames after Mapbox attaches it
      // — otherwise its initial transform paints at a stale projection for
      // one frame before settling, which reads as a flicker/duplicate.
      el.style.opacity = '0';
      originMarker = new window.mapboxgl.Marker({ element: el, anchor: 'bottom' })
        .setLngLat([filter.origin.lng, filter.origin.lat])
        .addTo(map);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.style.opacity = '1'; });
      });
    }

    function renderList() {
      list.innerHTML = '';

      if (visibleDealers.length === 0) {
        var empty = createElement('li', 'dealer-locator__empty');
        empty.textContent = 'No dealers found in that area. Try a wider search or reset the map.';
        list.appendChild(empty);
        return;
      }

      function dealerLabel(n) { return n + ' ' + (n === 1 ? 'dealer' : 'dealers'); }
      function makeHeading(text) {
        var li = createElement('li', 'dealer-locator__list-heading', { role: 'presentation' });
        li.textContent = text;
        return li;
      }

      // Header text + grouping depend on the active filter.
      //   null     — group by country when results span >1 country
      //   country  — "<Country> — X dealers"
      //   search   — "X results within Y miles" / fallback "X dealers"
      //   nearby   — same as search
      if (filter && filter.kind === 'country') {
        list.appendChild(makeHeading(filter.country + ' — ' + dealerLabel(visibleDealers.length)));
        for (var ci = 0; ci < visibleDealers.length; ci++) {
          list.appendChild(renderCard(visibleDealers[ci]));
        }
        return;
      }

      if (filter && (filter.kind === 'search' || filter.kind === 'nearby')) {
        var allOutsideRadius = visibleDealers.every(function (d) {
          return typeof d.distance !== 'number' || d.distance > config.radius;
        });
        var heading = allOutsideRadius
          ? dealerLabel(visibleDealers.length)
          : visibleDealers.length + ' dealers within ' + config.radius + ' miles';
        list.appendChild(makeHeading(heading));
        for (var si = 0; si < visibleDealers.length; si++) {
          list.appendChild(renderCard(visibleDealers[si]));
        }
        return;
      }

      // No filter — group by canonical country, unless everything's one country.
      var counts = {};
      for (var i = 0; i < visibleDealers.length; i++) {
        var c = canonicalCountry(visibleDealers[i].country);
        counts[c] = (counts[c] || 0) + 1;
      }
      var useGroupHeaders = Object.keys(counts).length > 1;

      if (!useGroupHeaders) {
        list.appendChild(makeHeading(dealerLabel(visibleDealers.length)));
        for (var j = 0; j < visibleDealers.length; j++) {
          list.appendChild(renderCard(visibleDealers[j]));
        }
      } else {
        var lastCountry = null;
        for (var k = 0; k < visibleDealers.length; k++) {
          var d = visibleDealers[k];
          var country = canonicalCountry(d.country);
          if (country !== lastCountry) {
            lastCountry = country;
            list.appendChild(makeHeading(country + ' — ' + dealerLabel(counts[country] || 0)));
          }
          list.appendChild(renderCard(d));
        }
      }
    }

    function renderCard(dealer) {
      var li = createElement('li', 'dealer-card' + (dealer.id === selectedId ? ' is-active' : ''));

      var btn = createElement('button', 'dealer-card__button', {
        type: 'button',
        'aria-label': 'Show ' + dealer.name + ' on map',
      });
      li.appendChild(btn);

      var name = createElement('span', 'dealer-card__name');
      name.textContent = dealer.name;
      btn.appendChild(name);

      if (dealer.addressLine) {
        var loc = createElement('span', 'dealer-card__location');
        loc.innerHTML =
          '<svg class="dealer-card__pin" viewBox="0 0 24 24" aria-hidden="true">' +
            '<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" fill="currentColor"/>' +
          '</svg>';
        loc.appendChild(document.createTextNode(dealer.addressLine));
        btn.appendChild(loc);
      }

      if (typeof dealer.distance === 'number') {
        var dist = createElement('span', 'dealer-card__distance');
        dist.textContent =
          dealer.distance.toFixed(dealer.distance < 10 ? 1 : 0) + ' mi away';
        btn.appendChild(dist);
      }

      var actions = createElement('div', 'dealer-card__actions');
      var primary = createElement('span', 'dealer-card__action dealer-card__action--primary');
      primary.textContent = 'View Details';
      actions.appendChild(primary);

      if (dealer.mapsUrl) {
        var directions = createElement('a', 'dealer-card__action dealer-card__action--secondary', {
          href: dealer.mapsUrl,
          target: '_blank',
          rel: 'noopener noreferrer',
        });
        directions.innerHTML =
          '<svg class="dealer-card__action-icon" viewBox="0 0 24 24" aria-hidden="true">' +
            '<path d="M21.71 11.29 12.71 2.29a1 1 0 0 0-1.42 0l-9 9a1 1 0 0 0 0 1.42l9 9a1 1 0 0 0 1.42 0l9-9a1 1 0 0 0 0-1.42zM14 14.5V12h-4v3H8v-4a1 1 0 0 1 1-1h5V7.5L17.5 11z" fill="currentColor"/>' +
          '</svg>Directions';
        actions.appendChild(directions);
      }

      li.appendChild(actions);

      li.addEventListener('click', function (e) {
        if (e.target.closest('.dealer-card__actions a')) return;
        selectDealer(dealer.id);
      });

      return li;
    }

    function renderMarkers() {
      if (!mapReady || !map) return;

      // Clean up whatever the previous mode rendered
      for (var i = 0; i < markers.length; i++) {
        var markerEl = markers[i].getElement();
        var markerWrapper = markerEl.closest ? markerEl.closest('.mapboxgl-marker') : markerEl.parentElement;
        if (markerWrapper) markerWrapper.style.display = 'none';
        markers[i].remove();
      }
      markers = [];
      if (clusterClickHandler) {
        map.off('click', CLUSTER_LAYER, clusterClickHandler);
        map.off('click', UNCLUSTERED_LAYER, unclusteredClickHandler);
        clusterClickHandler = null;
        unclusteredClickHandler = null;
      }
      var layerIds = [
        CLUSTER_COUNT_LAYER, CLUSTER_LAYER, CLUSTER_SHADOW_LAYER,
        UNCLUSTERED_COUNT_LAYER, UNCLUSTERED_LAYER, UNCLUSTERED_SHADOW_LAYER,
      ];
      for (var l = 0; l < layerIds.length; l++) {
        if (map.getLayer(layerIds[l])) map.removeLayer(layerIds[l]);
      }
      if (map.getSource(SOURCE_ID)) map.removeSource(SOURCE_ID);

      if (suppressMarkerRender) return;

      var dealersWithCoords = visibleDealers.filter(function (d) { return d.hasLatLng; });

      // search/nearby: show individual markers so each result is directly
      // selectable without an extra click to expand a cluster.
      // country: use superclusters at any zoom level that would normally cluster
      // (both 'country' and 'super' modes), so country clusters never reappear
      // while a country filter is active.
      var effectiveMode;
      if (filter && (filter.kind === 'search' || filter.kind === 'nearby')) {
        effectiveMode = 'none';
      } else if (filter && filter.kind === 'country' && clusterMode !== 'none') {
        effectiveMode = 'super';
      } else {
        effectiveMode = clusterMode;
      }

      if (effectiveMode === 'country') {
        var groups = {};
        for (var g = 0; g < dealersWithCoords.length; g++) {
          var d = dealersWithCoords[g];
          var key = canonicalCountry(d.country);
          // Skip dealers without a recognized country — we have nowhere to
          // anchor a cluster for them at world view.
          if (key === 'Other') continue;
          if (!groups[key]) groups[key] = [];
          groups[key].push(d);
        }
        for (var country in groups) {
          if (!Object.prototype.hasOwnProperty.call(groups, country)) continue;
          markers.push(renderCountryCluster(country, groups[country]));
        }
      } else if (effectiveMode === 'super') {
        renderSuperclusterLayers(dealersWithCoords);
      } else {
        for (var m = 0; m < dealersWithCoords.length; m++) {
          markers.push(renderPointMarker(dealersWithCoords[m]));
        }
      }
    }

    function renderCountryCluster(country, group) {
      var center = getCountryCenter(country);
      var sumLng = 0;
      var sumLat = 0;
      for (var i = 0; i < group.length; i++) { sumLng += group[i].lng; sumLat += group[i].lat; }
      var lng = center ? center[0] : sumLng / group.length;
      var lat = center ? center[1] : sumLat / group.length;

      var el = createElement('button', 'dealer-locator__cluster', {
        type: 'button',
        'aria-label': group.length + ' dealers in ' + country + '. Zoom in to see them.',
      });
      var countryEl = createElement('span', 'dealer-locator__cluster-country');
      countryEl.textContent = country;
      var countEl = createElement('span', 'dealer-locator__cluster-count');
      countEl.style.color = accentColor;
      countEl.textContent = group.length + ' ' + (group.length === 1 ? 'dealer' : 'dealers');
      el.appendChild(countryEl);
      el.appendChild(countEl);

      el.addEventListener('click', function (e) {
        e.stopPropagation();
        map.easeTo({ center: [lng, lat], duration: 600 });
        applyFilter({ kind: 'country', country: country });
      });

      // Hide the marker for the first two frames after Mapbox attaches it
      // — otherwise its initial transform paints at a stale projection for
      // one frame before settling, which reads as a flicker/duplicate.
      el.style.opacity = '0';
      var marker = new window.mapboxgl.Marker({ element: el, anchor: 'center' })
        .setLngLat([lng, lat])
        .addTo(map);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.style.opacity = '1'; });
      });
      return marker;
    }

    function renderSuperclusterLayers(dealersWithCoords) {
      map.addSource(SOURCE_ID, {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: dealersWithCoords.map(function (d) {
            return {
              type: 'Feature',
              geometry: { type: 'Point', coordinates: [d.lng, d.lat] },
              properties: { id: d.id },
            };
          }),
        },
        cluster: true,
        // clusterMinPoints: 1 promotes every dealer (even isolated ones) into
        // a "cluster of 1" so the visual is uniform — no mix of bare dots and
        // labeled circles at zoom 4. Singletons are handled in the click
        // handler by selecting the dealer instead of expanding the cluster.
        clusterMinPoints: 1,
        clusterRadius: 50,
        clusterMaxZoom: SUPER_MAX,
      });

      map.addLayer({
        id: CLUSTER_SHADOW_LAYER,
        type: 'circle',
        source: SOURCE_ID,
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': '#000000',
          'circle-opacity': 0.28,
          'circle-radius': CLUSTER_SHADOW_RADIUS_EXPR,
          'circle-translate': [0, 2.5],
          'circle-blur': 1,
        },
      });

      map.addLayer({
        id: CLUSTER_LAYER,
        type: 'circle',
        source: SOURCE_ID,
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': '#ffffff',
          'circle-radius': CLUSTER_RADIUS_EXPR,
        },
      });

      map.addLayer({
        id: CLUSTER_COUNT_LAYER,
        type: 'symbol',
        source: SOURCE_ID,
        filter: ['has', 'point_count'],
        layout: {
          'text-field': ['get', 'point_count_abbreviated'],
          'text-font': ['DIN Pro Bold', 'Arial Unicode MS Bold'],
          'text-size': 14,
          'text-allow-overlap': true,
        },
        paint: { 'text-color': accentColor },
      });

      // Unclustered point layers — render isolated singletons (which
      // supercluster can't promote to a cluster because they have no
      // neighbors within clusterRadius) with the same red-circle "1" badge.
      var unclusteredFilter = ['!', ['has', 'point_count']];
      map.addLayer({
        id: UNCLUSTERED_SHADOW_LAYER,
        type: 'circle',
        source: SOURCE_ID,
        filter: unclusteredFilter,
        paint: {
          'circle-color': '#000000',
          'circle-opacity': 0.28,
          'circle-radius': 28,
          'circle-translate': [0, 2.5],
          'circle-blur': 1,
        },
      });

      map.addLayer({
        id: UNCLUSTERED_LAYER,
        type: 'circle',
        source: SOURCE_ID,
        filter: unclusteredFilter,
        paint: {
          'circle-color': '#ffffff',
          'circle-radius': 16,
        },
      });

      map.addLayer({
        id: UNCLUSTERED_COUNT_LAYER,
        type: 'symbol',
        source: SOURCE_ID,
        filter: unclusteredFilter,
        layout: {
          'text-field': '1',
          'text-font': ['DIN Pro Bold', 'Arial Unicode MS Bold'],
          'text-size': 14,
          'text-allow-overlap': true,
        },
        paint: { 'text-color': accentColor },
      });

      clusterClickHandler = function (e) {
        var features = map.queryRenderedFeatures(e.point, { layers: [CLUSTER_LAYER] });
        var feat = features[0];
        if (!feat) return;
        var props = feat.properties || {};
        var source = map.getSource(SOURCE_ID);

        // With clusterMinPoints: 1, a "cluster" of one is just a single
        // dealer. Treat it as a selection rather than a zoom-in.
        if (props.point_count === 1 && source && source.getClusterLeaves) {
          source.getClusterLeaves(props.cluster_id, 1, 0, function (err, leaves) {
            if (err) return;
            var id = leaves[0] && leaves[0].properties && leaves[0].properties.id;
            if (id) selectDealer(id);
          });
          return;
        }

        if (!source || !source.getClusterExpansionZoom) return;
        source.getClusterExpansionZoom(props.cluster_id, function (err, zoom) {
          if (err) return;
          map.easeTo({
            center: feat.geometry.coordinates,
            zoom: zoom + 1,
            duration: 500,
          });
        });
      };
      map.on('click', CLUSTER_LAYER, clusterClickHandler);

      unclusteredClickHandler = function (e) {
        var features = map.queryRenderedFeatures(e.point, { layers: [UNCLUSTERED_LAYER] });
        var feat = features[0];
        if (!feat) return;
        var id = feat.properties && feat.properties.id;
        if (id) selectDealer(id);
      };
      map.on('click', UNCLUSTERED_LAYER, unclusteredClickHandler);

      map.on('mouseenter', CLUSTER_LAYER, function () { map.getCanvas().style.cursor = 'pointer'; });
      map.on('mouseleave', CLUSTER_LAYER, function () { map.getCanvas().style.cursor = ''; });
      map.on('mouseenter', UNCLUSTERED_LAYER, function () { map.getCanvas().style.cursor = 'pointer'; });
      map.on('mouseleave', UNCLUSTERED_LAYER, function () { map.getCanvas().style.cursor = ''; });
    }

    function renderPointMarker(dealer) {
      var el = createElement('div', 'dealer-locator__marker');
      var dot = createElement('span', 'dealer-locator__marker-dot');
      dot.style.background = accentColor;
      el.appendChild(dot);

      var marker = new window.mapboxgl.Marker({ element: el, anchor: 'bottom' })
        .setLngLat([dealer.lng, dealer.lat])
        .addTo(map);

      el.addEventListener('click', function (e) {
        e.stopPropagation();
        selectDealer(dealer.id);
      });
      return marker;
    }

    function selectDealer(id) {
      selectedId = id;
      renderList();
      if (!mapReady || !map) return;
      var dealer = null;
      for (var i = 0; i < allDealers.length; i++) {
        if (allDealers[i].id === id) { dealer = allDealers[i]; break; }
      }
      if (!dealer || !dealer.hasLatLng) return;

      if (popup) popup.remove();
      var html =
        '<div class="dealer-locator__info-window">' +
          '<strong>' + escapeHtml(dealer.name) + '</strong>' +
          '<div>' + escapeHtml(dealer.addressLine) + '</div>' +
          (dealer.mapsUrl
            ? '<a href="' + escapeHtml(dealer.mapsUrl) + '" target="_blank" rel="noopener">Get Directions</a>'
            : '') +
        '</div>';

      popup = new window.mapboxgl.Popup({ offset: 18, closeButton: true })
        .setLngLat([dealer.lng, dealer.lat])
        .setHTML(html)
        .addTo(map);

      map.flyTo({
        center: [dealer.lng, dealer.lat],
        zoom: Math.max(map.getZoom(), 9),
        essential: true,
      });
    }

    function handleSearch(query) {
      if (!config.mapboxToken) return;
      setLoading(true);
      geocodePostcode(query, config.mapboxToken)
        .then(function (result) {
          if (!result) return;
          applyFilter({
            kind: 'search',
            origin: { lat: result.lat, lng: result.lng },
            query: query,
          });
        })
        .catch(function () { /* swallow — no status UI today */ })
        .then(function () { setLoading(false); });
    }

    function handlePlaceSelected(place) {
      if (!place || !place.geometry || !place.geometry.location) return;
      var loc = place.geometry.location;
      var lat = typeof loc.lat === 'function' ? loc.lat() : loc.lat;
      var lng = typeof loc.lng === 'function' ? loc.lng() : loc.lng;
      if (!isFinite(lat) || !isFinite(lng)) return;
      zipInput.value = place.formatted_address || place.name || zipInput.value;
      applyFilter({
        kind: 'search',
        origin: { lat: lat, lng: lng },
        query: zipInput.value,
      });
    }

    function setupGoogleAutocomplete() {
      if (!config.googleMapsApiKey) return;
      whenGooglePlacesReady(function () {
        if (!window.google || !window.google.maps || !window.google.maps.places) return;
        var autocomplete = new window.google.maps.places.Autocomplete(zipInput, {
          fields: ['geometry', 'formatted_address', 'name'],
          // No `types` restriction → addresses, cities, ZIPs/postal codes,
          // regions, and other geocodable places all surface.
        });
        autocomplete.addListener('place_changed', function () {
          handlePlaceSelected(autocomplete.getPlace());
        });
      });
    }

    function handleNearby() {
      nearbyBtn.blur();
      if (config.debug) {
        applyFilter({ kind: 'nearby', origin: { lat: 45.1401, lng: -92.6865 } });
        return;
      }
      if (!navigator.geolocation) {
        window.alert('Location services are not available in this browser.');
        return;
      }
      if (!window.isSecureContext) {
        window.alert('Location requires a secure (HTTPS) connection.');
        return;
      }
      setLoading(true);
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          setLoading(false);
          applyFilter({
            kind: 'nearby',
            origin: { lat: pos.coords.latitude, lng: pos.coords.longitude },
          });
        },
        function (err) {
          setLoading(false);
          var msg = 'Unable to get your location.';
          if (err) {
            if (err.code === 1) msg = 'Location permission was denied. Enable location access for this site in your browser settings.';
            else if (err.code === 2) msg = 'Your location is unavailable right now. Try again or search by ZIP.';
            else if (err.code === 3) msg = 'Location request timed out. Try again.';
            if (err.message) msg += ' (' + err.message + ')';
          }
          window.alert(msg);
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
      );
    }

    function handleReset() {
      if (mapReady && map) {
        suppressMarkerRender = true;
        map.once('moveend', function () {
          suppressMarkerRender = false;
          renderMarkers();
        });
      }
      applyFilter(null);
    }

    // --- Wire form events ---
    function updateClearBtn() {
      if (clearBtn) clearBtn.style.display = zipInput.value ? '' : 'none';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var trimmed = zipInput.value.trim();
      if (!trimmed) return;
      handleSearch(trimmed);
    });
    zipInput.addEventListener('input', function () {
      updateClearBtn();
      persistCurrentState();
    });
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        zipInput.value = '';
        updateClearBtn();
        zipInput.focus();
      });
    }
    nearbyBtn.addEventListener('click', handleNearby);
    resetBtn.addEventListener('click', handleReset);

    setupGoogleAutocomplete();

    // --- Restore persisted state (before first render so the initial paint
    // already reflects the previous session's search). applyFilter handles
    // list/marker updates; map view re-applies once the map loads below.
    var restored = storage.load();
    if (restored) {
      if (typeof restored.queryText === 'string') {
        zipInput.value = restored.queryText;
        updateClearBtn();
      }
      if (isValidPersistedFilter(restored.filter)) {
        applyFilter(restored.filter);
      }
    }

    // --- Initial render ---
    if (!restored || !isValidPersistedFilter(restored.filter)) {
      renderList();
    }

    // --- Map init ---
    if (!config.mapboxToken) {
      setFallback(
        "Add a Mapbox access token in this section's settings to enable the interactive map. Dealer results will still load from the shop metafield."
      );
      return;
    }
    if (!window.mapboxgl) {
      setFallback('Mapbox library failed to load. Check your network and try again.');
      return;
    }

    window.mapboxgl.accessToken = config.mapboxToken;

    try {
      map = new window.mapboxgl.Map({
        container: mapEl,
        style: MAP_STYLE,
        // Force flat Web Mercator instead of the Standard style's default
        // 3D globe. The globe projection keeps refining its matrices for
        // a while after `idle`, which causes DOM markers anchored by
        // lat/lng to visibly snap when the user next interacts.
        projection: 'mercator',
        center: [config.defaultCenter.lng, config.defaultCenter.lat],
        zoom: config.defaultZoom,
        minZoom: 2,
        pitch: 0,
        bearing: 0,
        maxPitch: 0,
        dragRotate: false,
        pitchWithRotate: false,
        touchPitch: false,
        cooperativeGestures: true,
        attributionControl: false,
        logoPosition: 'bottom-right',
      });
    } catch (err) {
      setFallback('Mapbox failed to initialize: ' + ((err && err.message) || 'unknown error'));
      return;
    }

    map.addControl(new window.mapboxgl.AttributionControl({ compact: true }), 'bottom-right');
    map.addControl(new window.mapboxgl.NavigationControl({ showCompass: false }), 'top-right');

    map.on('style.load', function () {
      try {
        map.setConfigProperty('basemap', 'theme', 'monochrome');
        map.setConfigProperty('basemap', 'lightPreset', 'day');
        map.setConfigProperty('basemap', 'show3dObjects', false);
        map.setConfigProperty('basemap', 'showPointOfInterestLabels', false);
        map.setConfigProperty('basemap', 'showTransitLabels', false);
      } catch (e) {
        // older mapbox-gl or non-standard style — ignore config setters
      }
    });

    map.on('load', function () {
      mapReady = true;
      renderMarkers();
      // If a filter was restored from sessionStorage before the map
      // finished loading, applyFilter's calls to renderOriginMarker /
      // applyMapView were no-ops. Re-run them now.
      if (filter) {
        renderOriginMarker();
        applyMapView();
        updateResetButton();
      }
    });

    map.on('zoom', function () {
      var next = computeMode(map.getZoom());
      if (next !== clusterMode) {
        clusterMode = next;
        // Clear the stale layer right away so it doesn't drift through
        // the rest of the zoom animation, then place the new layer once
        // the camera settles.
        suppressMarkerRender = true;
        renderMarkers();
        suppressMarkerRender = false;
        map.once('zoomend', function () {
          renderMarkers();
        });
      }
    });

    map.on('zoomend', updateResetButton);

    map.on('error', function (e) {
      var msg = (e && e.error && e.error.message) || 'Mapbox error';
      if (/access token|401|403/i.test(msg)) {
        setFallback('Mapbox rejected the access token or URL restrictions. Check the token settings.');
      }
    });

    if (config.debug) {
      var tag = '[dealer-locator]';
      var snapshot = function (label) {
        var c = map.getCenter();
        console.log(tag, label, {
          center: { lat: +c.lat.toFixed(5), lng: +c.lng.toFixed(5) },
          zoom: +map.getZoom().toFixed(2),
          bearing: +map.getBearing().toFixed(2),
          pitch: +map.getPitch().toFixed(2),
        });
      };
      map.on('load', function () { snapshot('load'); });
      map.on('moveend', function () { snapshot('moveend'); });
      map.on('zoomend', function () { snapshot('zoomend'); });
      map.on('click', function (e) {
        console.log(tag, 'click', {
          lat: +e.lngLat.lat.toFixed(5),
          lng: +e.lngLat.lng.toFixed(5),
        });
      });
      map.on('error', function (e) {
        console.warn(tag, 'error', (e && e.error && e.error.message) || e);
      });
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-dealer-locator-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
